import React, { useState } from 'react';
import { View, Modal } from 'react-native';
import { createStyleSheet, useStyles } from 'react-native-unistyles';
import { translate } from '../../services/translate';
import MyAppText from '../../components/MyAppText';
import CustomButton, { ButtonTypes } from '../../components/CustomButton';
import { WindowInformation } from '../../services/window-information';
import MyDropDownPicker from '../../components/MyDropDownPicker';


interface ModalProps {
    isModalVisible: boolean;
    setModalVisible: (value: boolean) => void;
    onSubmit: (serverPoolId: string) => void;
    onCancel?: () => void;
    itemName?: string;
    customMessage?: string;
    customConfirm?: string;
    onSubmitType?: ButtonTypes;
    isLoading?: boolean;
    maxWidth?: number;
    availableServerPools: { id: string; }[];
}

export default function PurgeCamerasModal({
    isModalVisible,
    setModalVisible,
    onSubmit,
    onCancel,
    maxWidth,
    availableServerPools,
}: ModalProps) {
    const { styles } = useStyles(styleSheet);
    const windowInfo = WindowInformation();

    const [serverPoolDropdownOpen, setServerPoolDropdownOpen] = useState(false);
    const [serverPoolId, setServerPoolId] = useState<string | null>(null);

    return (
        <Modal
            visible={isModalVisible}
            animationType='fade'
            onRequestClose={() => {
                onCancel && onCancel();
                setModalVisible(false);
            }}
            transparent={true}
        >
            <View style={styles.container}>
                <View style={styles.body(windowInfo.isMobile, maxWidth)}>
                    <MyAppText style={styles.confirmationText}>{translate('selectServerPoolToPurgeCameras')}</MyAppText>
                    <View style={{ zIndex: 3 }}>
                        <MyDropDownPicker
                            placeholder={translate('serverPools')}
                            searchable={true}
                            items={[{}, ...availableServerPools.map(sp => ({
                                value: sp.id,
                                label: sp.id,
                            }))]}
                            open={serverPoolDropdownOpen}
                            setOpen={setServerPoolDropdownOpen}
                            setValue={setServerPoolId}
                            value={serverPoolId}
                            zIndex={3}
                        />
                    </View>
                    <View style={styles.confirmButtonsView}>
                        <CustomButton
                            onPress={() => {
                                onCancel && onCancel();
                                setModalVisible(false);
                            }}
                            text={translate('no')}
                            type='secondary' />
                        <CustomButton
                            onPress={() => {
                                if (!serverPoolId) {
                                    return;
                                }
                                onSubmit(serverPoolId);
                                setModalVisible(false);
                            }}
                            disabled={!serverPoolId}
                            type={'primary'}
                            text={translate('confirm')} />
                    </View>
                </View>
            </View>
        </Modal>
    );
}

const styleSheet = createStyleSheet((theme) => ({
    container: {
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: '#31313199',
        flex: 1
    },
    body: (isMobile: boolean, maxWidth?: number) => ({
        width: isMobile ? '95%' : '80%',
        maxWidth: maxWidth,
        backgroundColor: theme.colors.card.background,
        flexDirection: 'column',
        borderRadius: 4,
        padding: 25,
        rowGap: 20,
    }),
    headerText: {
        fontSize: 20,
    },
    buttonsView: {
        flexDirection: 'row',
        alignItems: 'center',
        flexWrap: 'wrap',
        justifyContent: 'flex-end',
        gap: 20
    },
    confirmationText: {
        fontSize: 20,
    },
    confirmButtonsView: {
        flexDirection: 'row',
        alignItems: 'center',
        flexWrap: 'wrap',
        justifyContent: 'space-between',
    }
}));
